import '../styles/main.scss';
import lazySizes from "lazysizes";
import './tools/lazybg';
import './tools/burger';
import './tools/imageViewer';